export default "__VITE_ASSET__ukyXREIe__"